import React from 'react';

import Question from 'containers/Shared/Tasks/Task/Question';

import { useTaskCreateStore } from 'store/task/useTaskCreateStore';

const Task = () => {
	// Use task's create store
	const questions = useTaskCreateStore(state => state.task.questions);

	return (
		<div className="flex flex-col gap-4">
			{questions.map((question, idx) =>
				<Question
					idx={idx}
					key={question.key}
					question={question}
				/>
			)}
		</div>
	);
};

export default Task;